<template>
  <div class="mock" aria-hidden="true">
    <div class="topbar"><i></i><i></i><i></i><span class="search"></span></div>
    <div class="body">
      <div class="side">
        <span class="logo"></span>
        <span v-for="n in 6" :key="n" class="row" :class="{ on: n === 2 }"></span>
      </div>
      <div class="main">
        <div class="kpis">
          <div v-for="(c, n) in kpis" :key="n" class="kpi">
            <span class="k-label"></span>
            <span class="k-value"></span>
            <span class="k-dot" :style="{ background: c }"></span>
          </div>
        </div>
        <div class="panels">
          <div class="chart">
            <span v-for="(h, n) in bars" :key="n" class="bar" :style="{ height: `${h}%` }"></span>
          </div>
          <div class="list">
            <div v-for="n in 5" :key="n" class="item">
              <span class="av" :style="{ background: kpis[n % 4] }"></span>
              <span class="line"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// A drawn product screen, shown until a real screenshot is uploaded in the CMS.
const kpis = ['var(--chip-1)', 'var(--chip-5)', 'var(--chip-4)', 'var(--chip-3)']
const bars = [38, 52, 44, 66, 58, 78, 70, 90, 82, 100]
</script>

<style scoped>
.mock {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  color: var(--ink);
}

.topbar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--divider);
}

.topbar i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--divider);
}

.search {
  margin-inline-start: 14px;
  height: 10px;
  width: min(220px, 40%);
  border-radius: 99px;
  background: var(--surface);
}

.body {
  flex: 1;
  display: flex;
  min-height: 0;
}

.side {
  width: clamp(54px, 14%, 190px);
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-inline-end: 1px solid var(--divider);
}

.logo {
  height: 18px;
  width: 60%;
  border-radius: 6px;
  background: var(--ink);
  margin-bottom: 8px;
}

.row {
  height: 12px;
  border-radius: 6px;
  background: var(--surface);
}

.row.on {
  background: var(--surface-hover);
}

.main {
  flex: 1;
  padding: clamp(10px, 2vw, 24px);
  display: flex;
  flex-direction: column;
  gap: clamp(10px, 2vw, 20px);
  background: #fafaf8;
  min-width: 0;
}

.kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: clamp(8px, 1.4vw, 16px);
}

.kpi {
  position: relative;
  background: #fff;
  border: 1px solid var(--divider);
  border-radius: 12px;
  padding: clamp(8px, 1.4vw, 16px);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.k-label {
  height: 7px;
  width: 50%;
  border-radius: 4px;
  background: var(--divider);
}

.k-value {
  height: clamp(12px, 2vw, 22px);
  width: 70%;
  border-radius: 6px;
  background: var(--ink);
}

.k-dot {
  position: absolute;
  top: 12px;
  inset-inline-end: 12px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.panels {
  flex: 1;
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: clamp(8px, 1.4vw, 16px);
  min-height: 0;
}

.chart {
  background: #fff;
  border: 1px solid var(--divider);
  border-radius: 12px;
  padding: clamp(10px, 1.6vw, 20px);
  display: flex;
  align-items: flex-end;
  gap: clamp(4px, 1vw, 12px);
}

.bar {
  flex: 1;
  border-radius: 6px 6px 0 0;
  background: var(--ink);
  opacity: 0.9;
}

.bar:nth-child(odd) {
  background: var(--primary);
}

.list {
  background: #fff;
  border: 1px solid var(--divider);
  border-radius: 12px;
  padding: clamp(10px, 1.6vw, 18px);
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.4vw, 14px);
  overflow: hidden;
}

.item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.av {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
}

.line {
  height: 8px;
  flex: 1;
  border-radius: 4px;
  background: var(--surface);
}

@media (max-width: 560px) {
  .side {
    display: none;
  }
}
</style>
